
import React from 'react';
import Community from 'src/components/Community';

import s from './bottom.module.css';

const Bottom = () => (
    <div className={s.bottom}>
        <Community />
    </div>
)

export default Bottom;
